<template>

  <div>
    <div class="MySubscriptions wrapper">
      <keep-alive>
        <Header></Header>
      </keep-alive>

      <div class="top">
        <div class="detail">
          <div class="positionName">
            {{position.positionName}}
          </div>
          <div class="positionSalary">
            {{position.positionSalary}}
          </div>
          <div class="positionAddress">
            <div>
              <i  class="el-icon-location"></i>
              <span class="name">{{position.positionAddress}}</span>
            </div>
            <div style="margin-left: 25px">
              <i  class="el-icon-s-cooperation"></i>
              <span class="name">{{position.positionTime}}</span>
            </div>
            <div style="margin-left: 25px">
              <i  class="el-icon-location"></i>
              <span class="name">{{position.positionEducation}}</span>
            </div>

          </div>
          <div class="buttonStyle">
            <el-button v-if="position.positionCollect==='0'" icon="el-icon-star-off" @click="collectPosition()" class="collect">收藏职位</el-button>
            <el-button v-if="position.positionCollect==='1'" icon="el-icon-star-on" @click="collectPosition()" class="collect">已收藏</el-button>
            <el-button v-if="position.deliverStatus==='0'" class="push" @click="collectPass()">一键沟通</el-button>
            <el-button v-if="position.deliverStatus==='1'" class="push" style="background-color: gray;border: none" @click="collectPass()">已沟通</el-button>
          </div>

        </div>
      </div>
      <div class="description">
        <div>
          <div class="position">
            <div class="introduce">岗位介绍</div>
            <div style="display: flex">
              <div class="introduce1" >岗位描述</div>
              <div class="spanStyle"></div>
            </div>
            <div class="positionIntroduce">
              {{position.positionIntroduce}}
            </div>
            <div style="display: flex">
              <div class="introduce1" >岗位要求</div>
              <div class="spanStyle"></div>
            </div>
            <div class="positionIntroduce">
              {{position.positionAsk}}
            </div>
            <div style="display: flex">
              <div class="introduce1" >岗位福利</div>
              <div class="spanStyle"></div>
            </div>
            <div class="positionIntroduce">
              {{position.positionWelfare}}
            </div>
          </div>
          <div class="position" style="margin-top: 20px" id="enterprise-info">
            <div class="introduce" >公司信息</div>
            <div style="display: flex">
              <div class="introduce1" >公司介绍</div>
              <div class="spanStyle"></div>
            </div>
            <div class="positionIntroduce">
              {{company.companyIntroduce}}
            </div>
            <div style="display: flex">
              <div class="introduce1" >工商信息</div>
              <div class="spanStyle"></div>
            </div>
            <div class="positionIntroduce1">
              <div>
                <div style="font-size: 14px;color: #999;line-height: 20px;margin-bottom: 8px;">企业名称：</div>
                <div style="    font-size: 15px;line-height: 21px;padding: 0 5px 0 0;">{{company.companyName}}</div>
              </div>
              <div>
                <div style="font-size: 14px;color: #999;line-height: 20px;margin-bottom: 8px;">企业执照：</div>
                <div style="    font-size: 15px;line-height: 21px;padding: 0 5px 0 0;">{{company.companyLicense}}</div>
              </div>
              <div>
                <div style="font-size: 14px;color: #999;line-height: 20px;margin-bottom: 8px;">所属行业：</div>
                <div style="    font-size: 15px;line-height: 21px;padding: 0 5px 0 0;">{{company.companyIndustry}}</div>
              </div>
              <div>
                <div style="font-size: 14px;color: #999;line-height: 20px;margin-bottom: 8px;">注册地址：</div>
                <div style="    font-size: 15px;line-height: 21px;padding: 0 5px 0 0;">{{company.companyEmpower}}</div>
              </div>
              <div>
                <div style="font-size: 14px;color: #999;line-height: 20px;margin-bottom: 8px;">融资阶段：</div>
                <div style="    font-size: 15px;line-height: 21px;padding: 0 5px 0 0;">{{company.companyFinancing}}</div>
              </div>
              <div>
                <div style="font-size: 14px;color: #999;line-height: 20px;margin-bottom: 8px;">企业规模：</div>
                <div style="    font-size: 15px;line-height: 21px;padding: 0 5px 0 0;">{{company.companyScale}}</div>
              </div>
              <div>
                <div style="font-size: 14px;color: #999;line-height: 20px;margin-bottom: 8px;">企业官网：</div>
                <div style="    font-size: 15px;line-height: 21px;padding: 0 5px 0 0;">{{company.companyWebsite}}</div>
              </div>
              <div>
                <div style="font-size: 14px;color: #999;line-height: 20px;margin-bottom: 8px;">联系电话：</div>
                <div style="    font-size: 15px;line-height: 21px;padding: 0 5px 0 0;">{{company.companyPhone}}</div>
              </div>
              <div>
                <div style="font-size: 14px;color: #999;line-height: 20px;margin-bottom: 8px;">联系邮箱：</div>
                <div style="    font-size: 15px;line-height: 21px;padding: 0 5px 0 0;">{{company.companyEmail}}</div>
              </div>

            </div>
            <div style="display: flex">
              <div class="introduce1" >公司地址</div>
              <div class="spanStyle"></div>
            </div>
            <div class="positionIntroduce">
              <div id="index"><baidu-map class="map" style="width: 100%; height: 220px" :center="center" :zoom="zoom" @ready="handler" />
              </div>
            </div>

          </div>
          <div class="guss">
            <div class="name">猜你喜欢
            </div>
            <div class="middle">
              <li v-for="(lists,index) in list" :key="index">
                <div v-if="index<=1" class="listTotle" @click="personal(lists)">
                  <div class="detail">
                    <div >
                      <div>
                        <span class="positionName"> {{lists.positionName}}</span>
                        <span class="salaryName"> {{lists.positionSalary}}</span>
                      </div>
                      <div class="jobStyle">
                        <span class="jobStyle1">{{lists.positionTime}}</span>
                        <span class="jobStyle2">{{lists.positionEducation}}</span>
                      </div>
                    </div>
                    <div class="comLogo">
                      <img :src="baseURL + lists.companyAvatar" alt="" />
                    </div>
                    <div class="companyName">
                      <div class="name1">{{lists.companyName}} </div>
                      <div class="name2">{{lists.companyScale}} </div>
                    </div>
                    <div class="comButton">
                      <el-button class="companyBut"  @click="communicate()">立即沟通</el-button>
                    </div>



                  </div>
                  <div class="bottom">
                    <div class="address"> </div>
                    <div class="positionAddress">{{lists.positionAddress}}</div>

                  </div>

                </div>

              </li>

            </div>

          </div>
        </div>

        <div class="company">
          <div class="back"></div>
          <div class="detail">
            <div class="companyDetail">
              公司信息
            </div>
            <div class="companyLogo">
              <div class="comLogo">
                <img :src="baseURL + company.companyAvatar" alt="" />
              </div>
              <div class="comName">
               {{company.companyName}}
              </div>
            </div>
            <div class="comIntro">
              <div style="display: flex;margin-top: 8px;font-size: 14px">
                <i style="margin-top: 3px;margin-right: 5px" class="el-icon-suitcase-1"></i>
                <div class="titleName">企业行业：</div>
                <div class="titleDetail" style="color: #666666;">{{ company.companyIndustry }}</div>
              </div>
              <div style="display: flex; margin-top: 8px; font-size: 14px; overflow-wrap: break-word;">
                <i style="margin-top: 3px;margin-right: 5px" class="el-icon-school"></i>
                <div class="titleName">融资阶段：</div>
                <div class="titleDetail" style="color: #666666;overflow-wrap: break-word;">{{ company.companyFinancing }}</div>
              </div>
              <div style="display: flex;margin-top: 8px;font-size: 14px">
                <i style="margin-top: 3px;margin-right: 5px" class="el-icon-user"></i>
                <div class="titleName">企业规模：</div>
                <div class="titleDetail" style="color: #666666;">{{ company.companyScale }}</div>
              </div>
              <div style="display: flex;margin-top: 8px;font-size: 14px">
                <i style="margin-top: 3px;margin-right: 5px" class="el-icon-mobile-phone"></i>
                <div class="titleName">联系电话：</div>
                <div class="titleDetail" style="color: #666666;">{{ company.companyPhone }}</div>
              </div>



            </div>
            <div class="scan" style="margin:20px auto 24px auto">
              <el-button @click="japOther" class="scanButton" style="margin:20px 20px 24px 20px;width: 180px;height: 36px;border-radius: 4px 4px 4px 4px;opacity: 1;border: 1px solid #BF0022;opacity: 1;font-size: 14px;font-weight: 400;color: #BF0022;line-height: 16px;">查看详情</el-button>
            </div>

          </div>
        </div>
      </div>

      <div>
        <div v-if="isMobile===false">
          <el-dialog
                     title="立即沟通"
                     :visible.sync="cancleVisible"
                     width="680px"
                     :before-close="handleClose"
                     top="40vh"
          >
            <span>
              <div class="box1">
        <div style="display: flex;position:relative;" >
           <div style="display: flex;position:relative;">
          <div class="Photo">
              <img :src="positionData.interviewAvatar ? baseURL + positionData.interviewAvatar : avator" class="avatar" />
          </div>
          <div style="margin-left: 16px">
            <div class="userName">{{positionData.userName}}</div>
            <div style="display: flex;margin-top: 20px">
              <div class="iconStyle"><img src="../../assets/sex.png"/></div>
              <div v-if="positionData.sex!==null">
                <div class="userSex" >{{ positionData.sex }}</div>
              </div>
              <div class="userSex" v-else>---</div>
              <div class="iconStyle"><img src="../../assets/work.png"/></div>
              <div class="userSex" v-if="positionData.interviewDuties!==null">{{ positionData.interviewDuties}}</div>
              <div v-else class="userSex">---</div>
            </div>
            <div style="display: flex;margin-top: 21px">
              <div class="iconStyle"><i class="el-icon-mobile-phone"></i></div>
              <div class="userSex" v-if="positionData.interviewPhone!==null">{{ positionData.interviewPhone}}</div>
              <div v-else class="userSex">---</div>
              <div class="iconStyle"><i class="el-icon-message"></i></div>
              <div class="userSex" v-if="positionData.interviewEmail!==null">{{ positionData.interviewEmail }}</div>
              <div v-else class="userSex">---</div>
            </div>
          </div>

        </div>

        </div>


      </div>

            </span>
            <span slot="footer" class="dialog-footer">
    </span>
          </el-dialog>
        </div>
        <div v-if="isMobile===true" style="font-size: 14px" class="phone">
          <el-dialog
                     title="温馨提示"
                     :visible.sync="cancleVisible"
                     width="75%"
                     :before-close="handleClose"
                     top="35vh"
          >
            <span>欢迎使用油气人才，注册登录后体验完整服务~</span>
            <span slot="footer" class="dialog-footer">
      <el-button>
        <router-link to="/login">登录</router-link>
      </el-button>
      <el-button type="primary">
        <router-link to="/register">注册</router-link>
      </el-button>
    </span>
          </el-dialog>

        </div>
      </div>
    </div>
    <Footer v-if="isMobile === false"></Footer>
    <BottomBanner v-if="isMobile === true"></BottomBanner>
    <LoginTip
        :dialogVisibleLogin="dialogVisibleLogin"
        @hideDialog="hideDialogin"
    ></LoginTip>
  </div>

</template>


<script>

import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import BottomBanner from "@/components/BottomBanner.vue";
import LoginTip from "@/components/LoginTip.vue";
export default {

  name: "",

  props: [],

  components: { BottomBanner, Footer, Header,LoginTip},

  data() {

    return {
      center: "北京市",
      zoom: 0,
      dialogVisibleLogin:false,
      avator: require("@/assets/avator.png"),
      cancleVisible: false,
      isMobile: false,
      positionId:'',
      token: localStorage.getItem('access_token'),
      userId:  localStorage.getItem('userId'),
      position:'',
      list:'',
      company:'',
      companyId:'',
      baseURL: this.$utils.baseURL,
      positionInterviewId:'',
      positionData:'',
      load:false,
    }

  },
  created() {
    this.positionId = this.$route.query.positionId
    this.getPosition()
    this.positionlist()
  },
  beforeRouteUpdate(to, from, next) {
    // window.location.reload()
    window.scrollTo(0, 0,
    ); // 每次路由变化时滚动到页面顶部
    next();
  },
  methods: {
    hideDialogin() {
      this.dialogVisibleLogin = false;
    },
    handler({ BMap, map }) {
      console.log(BMap, map)
      this.center = "北京市朝阳区东湖渠翠西路8号";
      // 使用百度地图的地址解析服务获取位置的经纬度
      const geoc = new BMap.Geocoder();
      geoc.getPoint(this.center, (point) => {
        if (point) {
          // 添加标注并设置自定义图标
          const marker = new BMap.Marker(point);
          map.addOverlay(marker);

          // 将地图中心点设置为标注位置，并调整缩放级别
          map.centerAndZoom(point, 25); // 调整缩放级别为 16
        } else {
          console.error("Failed to get coordinates for the location:", this.center);
        }
      }, "北京市");

    },
    japOther() {
      // 使用 JavaScript 滚动到目标位置
      const targetElement = document.getElementById('enterprise-info');

      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth', // 可以选择平滑滚动
        });
      }
    },
      handleClose()
    {
      this.cancleVisible = false;
    },
    hide() {
      this.cancleVisible = false;
    },
    hideDialog(){
      this.cancleVisible = false;
    },
    // 详情
    personal(list){
      console.log(list)

      this.positionId=list.positionId
      this.$router.push({
        query: {
          positionId: list.positionId,
        },
      });

      window.location.reload();

    },
    getPosition() {
      console.log("---------positionId")
      console.log(this.positionId)
      this.$axios.get(`/system/position/detail/`+this.positionId, {
        params: {
          userId: this.userId,
          positionId: this.positionId,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: this.token,
        },
      })
          .then((res) => {
            this.position = res.data.data;
            this.companyId = res.data.data.companyId;
            this.positionInterviewId=res.data.data.positionInterviewId;
            console.log("-----------positon")
            console.log(this.position);
            this.getCompany();
          })
          .catch(error => {
            console.log(error);
          });

    },
    getCompany() {

      this.$axios.get("/system/company/" + this.companyId, {
        headers: {
          "Content-Type": "application/json",
          Authorization: this.token,
        },
      })
          .then((res) => {
            console.log("----------------------")
            console.log(res.data.data)
            this.company=res.data.data
            if (this.company.companyIntroduce.length > 20) {
              const truncatedText = this.company.companyIntroduce.slice(0, 20) + "…";
              this.company.companyIntroduce = truncatedText; // 保存截断后的内容到新字段
            } else {
              const truncatedText  = this.company.companyIntroduce; // 如果没有截断，保存原始内容
              this.company.companyIntroduce = truncatedText;
            }
          }).catch(error => {
        console.log(error)
      })
    },
    positionlist() {
      this.$axios.get("/system/position/select_list" , {
        headers: {
          "Content-Type": "application/json",
          Authorization: this.token,
        },
      })
          .then((res) => {
            this.list = res.data.rows;
          }).catch(error=>{
        console.log(error)
      })
    },
  //   收藏
    collectPosition(){
      console.log("shoucang",this.userId===null||this.userId===undefined)
      // 登陆
      if(this.userId===null||this.userId===undefined){
        console.log("555")
        this.dialogVisibleLogin=true
      }
    //   未登录

      else{

        console.log("1111")
        if(this.position.positionCollect==="0"){
          this.$axios.post(`/system/position_collect`, {
            userId:this.userId,
            positionId: this.positionId,
          }, {
            headers: {
              "Content-Type": "application/json",
              Authorization: this.token,
            },
          })
              .then((res) => {
                console.log(res.data);
                this.getPosition()
                this.$forceUpdate();
              })
              .catch(error => {
                console.log(error);
              });
        }
        else{
          this.$axios.delete(`/system/position_collect/${this.positionId}`, {
            headers: {
              "Content-Type": "application/json",
              Authorization: this.token,
            },
            params: {
              userId: this.userId,
              positionId: this.positionId,
            },
          })
              .then((res) => {
                console.log(res.data);
                this.getPosition();
                this.$forceUpdate();
              })
              .catch(error => {
                console.log(error);
              });

        }

      }





    },

    collectPush(){
      console.log(parseInt(this.userId))
      if(this.position.positionCollect==="0"){
        this.$axios.post(`/system/position_collect`, {
          userId:this.userId,
          positionId: this.positionId,
        }, {
          headers: {
            "Content-Type": "application/json",
            Authorization: this.token,
          },
        })
            .then((res) => {
              console.log(res.data);
              this.getPosition()
              this.$forceUpdate();
            })
            .catch(error => {
              console.log(error);
            });
      }
      else{
        this.$axios.delete(`/system/position_collect/${this.positionId}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: this.token,
          },
          params: {
            userId: this.userId,
            positionId: this.positionId,
          },
        })
            .then((res) => {
              console.log(res.data);

              this.getPosition();
              this.$forceUpdate();
            })
            .catch(error => {
              console.log(error);
            });

      }

    },
  //   一键沟通
    collectPass(){

      if(this.userId===null||this.userId===undefined){
        console.log("555")
        this.dialogVisibleLogin=true
      }
      else{
        this.cancleVisible = true;
        this.$axios.get(`/system/interview/`+parseInt(this.positionInterviewId), {

          headers: {
            "Content-Type": "application/json",
            Authorization: this.token,
          },
        })
            .then((res) => {
              console.log(res)
              this.positionData=res.data.data
            })
            .catch(error => {
              console.log(error);
            });
        this.$axios.post(`/system/deliveryStatus`, {
          positionId:  this.positionId,
          userId: this.userId
        }, {
          headers: {
            "Content-Type": "application/json",
            Authorization: this.token,
          },
        })
            .then((res) => {
              console.log(res.data);
              this.$message({
                message: res.data.msg,
                type: 'success'
              });
              this.getPosition();
              this.$forceUpdate();
            })
            .catch(error => {
              console.log(error);
            });

      }
      }


  },

  mounted() {
    window.scrollTo(0, 0); // 在页面加载时滚动到页面顶部
    // Check if the device width is less than 768px (example for mobile)
    this.isMobile = window.matchMedia("(max-width: 767px)").matches;

  }

}

</script>


<style type="text/scss" lang="scss" scoped>
::v-deep .BMap_Marker img {
  width: 40px;  /* 修改图标宽度 */
  height: 25px; /* 修改图标高度 */
}
.top{
  margin-top: 10px;
  width: 100vw;
  height: 224px;
  background: #ffffff;
  box-shadow: 0px 1px 16px 0px rgba(0,0,0,0.05);
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  .detail{
    margin: 54px auto 50px auto;
    width:1280px;
    position: relative;
    .positionName{
      height: 28px;
      font-size: 28px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 28px;
    }
    .positionSalary{
      height: 28px;
      margin-top: 24px;
      font-size: 28px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      color: #BF0022;
      line-height: 28px;
    }
    .positionAddress{
      display: flex;
      margin-top: 32px;
      height: 16px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 16px;
      .name{
        margin-left: 9px;
        margin-top: -1px;
      }

    }
    .buttonStyle{
      position: absolute;
      bottom: 5px;
      right: 5px;
      .collect{
        width: 141px;
        height: 48px;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        border: 1px solid #BF0022;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #BF0022;
        line-height: 16px;
      }
      .push{
        width: 240px;
        height: 48px;
        background: #BF0022;
        border-radius: 4px 4px 4px 4px;
        font-size: 16px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 16px;
        opacity: 1;
      }

    }
  }

}
.box1{
  height: fit-content;
  padding: 24px 30px 26px 30px ;
  background: #FFFFFF;
  box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.05);
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  .cancleStyle{
    margin-top: 46px;
    width: 128px;
    height: 44px;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid #BF0022;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color:  #BF0022;
    line-height: 20px;
    -webkit-background-clip: text;
  }
  .confirmStyle{

    margin-top: 46px;
    margin-left: 20px;
    cursor: pointer;
    border: none;
    width: 128px;
    height: 44px;
    background-color: #BF0022;
    border-radius: 4px 4px 4px 4px;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  ::v-deep .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
    position: relative;
  }

  ::v-deep .el-input--prefix .el-input__inner {
    padding-left: 15px;
  }
  ::v-deep .el-select {
    width: 100%;
  }
  ::v-deep .el-input__suffix {
    height: 100%;
    left: 240px;
    transition: all .3s;
    pointer-events: none;
  }

  .information{
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    column-gap: 48px;
    row-gap: 20px;
    padding-top: 32px;
    .title{
      height: 14px;
      font-size: 14px;
      font-weight: 400;
      color: #000000;
      line-height: 14px;
      -webkit-background-clip: text;
    }
    .titleInput{
      margin-top: 12px;
      .sexStyle1{
        width: 145px;
        height: 44px;
        background: #F8E9ECFF;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        border: 1px solid #BF0022;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #BF0022;
        line-height: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
      .sexStyle2{
        width: 145px;
        height: 44px;
        background: #FDFDFDFF;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        border:none;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: gray;
        cursor: pointer;
        line-height: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .editStyle{
    position: absolute;
    top:0;
    display: flex;
    right:0;
    height: 12px;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    cursor: pointer;
    .editLogo{
      width: 13px;
      height: 12px;
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
    }
    .editTitle{
      width: 28px;
      height: 16px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      color: #BF0022;
      line-height: 16px;
      margin-left:7px ;
    }
  }

  .Photo{
    width: 80px;
    height: 80px;
    border-radius: 45%;
    opacity: 1;
  }
  .userName{
    height: 24px;
    font-size: 20px;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    color: #333333;
    line-height: 24px;

  }
  .userName1{
    margin-top: 9px;
    width: 80px;
    height: 24px;
    font-size: 20px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #BF0022;
    line-height: 24px;
    -webkit-background-clip: text;

  }
  .userName2{
    margin-top: 14px;
    width: 720px;
    color: gray;
    height: 24px;
    opacity: 1;

  }
  .userSex{
    height: 16px;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 16px;
    margin-left: 6px;
    margin-right: 32px;
  }
  .iconStyle{
    width: 14px;
    height: 15px;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
  }
}
.description{
  margin: 24px auto 50px auto;
  width: 1280px;
  position: relative;
  display: flex;

  .position{
    width:95%;
    height: auto;
    background: #FFFFFF;
    box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.05);
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    padding: 18px 30px;
    .introduce{
      width: 72px;
      height: 20px;
      font-size: 18px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 20px;
    }
    .introduce1{
      margin-top: 24px;
      height: 16px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      color: #050505;
      line-height: 16px;
    }
    .positionIntroduce{
      margin-top: 24px;
      width: auto;
      height: auto;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 28px;
    }
    .positionIntroduce1{
      margin-top: 24px;
      width: auto;
      height: auto;
      background-color: rgba(102, 102, 102, 0.1);
      padding: 10px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 28px;
      display: grid;
      //grid-template-columns:repeat(3,1fr);
      grid-template-columns:minmax(0,1.5fr)minmax(0,0.8fr)minmax(0,1fr);
      column-gap: 5px;
      row-gap: 10px;
    }
    .spanStyle{
      margin-top: 32px;
      margin-left: 12px;
      width:90%;
      height: 1px;
      background: #F5F5F5;
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
    }
  ;
  }
  .guss{
    margin-top: 20px;
    .name{
      width: 72px;
      height: 20px;
      font-size: 18px;
      font-family: 'PingFang SC', 'PingFang SC';
      font-weight: 600;
      color: #333333;
      line-height: 20px;
    }
    .middle{
      overflow:hidden;
      width:95%;
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
      list-style: none;

      .pagination-container {
        position: sticky;
        margin-top: 20px;
        padding: 10px;
        bottom: 0;
        width: 99%;
        text-align: center;
        background-color: #fff;
      }

      .listTotle{
        margin-top: 20px;
        width: 100%;
        height: 142px;
        background: #FFFFFF;
        box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.05);
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        .detail{
          padding: 20px;
          display: flex;
          cursor: pointer;
          position: relative;
          .positionName{
            width: 64px;
            height: 16px;
            font-size: 16px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 600;
            color: #333333;
            line-height: 16px;
          }
          .positionName:hover{
            color: #BF0022;
          }
          .salaryName{
            margin-left: 12px;
            width: 41px;
            height: 16px;
            font-size: 16px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            color: #BF0022;
            line-height: 16px;
          }
          .jobStyle{
            display: flex;
            margin-top: 16px;
            width: 18vw;
            .jobStyle1{
              font-size: 12px;
              font-weight: 400;
              color: #666666;
              background-color: #F5F5F5;
              padding:3px 10px;
            }
            .jobStyle1:hover{
              color:#BF0022;
              transform: scale(1.2);
              transition: transform 0.3s ease-in-out; /* 添加过渡效果 */
            }
            .jobStyle2
            {
              font-size: 12px;
              font-weight: 400;
              color: #666666;
              background-color: #F5F5F5;
              padding:3px 10px;
              margin-left:0.42vw
            }
            .jobStyle2:hover{
              color:#BF0022;
              transform: scale(1.2);
              transition: transform 0.3s ease-in-out; /* 添加过渡效果 */
            }
          }
          .comLogo{
            position: absolute;
            width: 54px;
            height: 54px;
            border-radius: 2px 2px 2px 2px;
            opacity: 1;
            border: 1px solid rgba(0,0,0,0.02);
            margin-left: 25.8vw;
          }
          .companyName{
            position: absolute;
            border-radius: 2px 2px 2px 2px;
            opacity: 1;
            margin-left:31vw;
            .name1{
              width: 140px;
              margin-top: 6px;
              height: 16px;
              font-size: 14px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 500;
              color: #333333;
              line-height: 16px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .name2{
              height: 16px;
              margin-top: 10px;
              font-size: 13px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              color: #666666;
              line-height: 16px;
            }
          }
          .comButton{
            position: absolute;
            right: 20px;
            top:31px;
            cursor: pointer;
            .companyBut{
              width: 92px;
              height: 32px;
              border: none;
              font-size: 14px;
              font-weight: 400;
              color: #BF0022;
              background: #FAEBEE;
              border-radius: 15px 15px 15px 15px;
              opacity: 1;
            }
            .companyBut:hover {
              /* 此处是鼠标悬浮时的样式 */
              color: #FFFFFF;
              background: #BF0022;
              /* 你可以添加其他的样式以突出悬浮状态 */
            }


            ::v-deep .el-button{
              padding: 5px 10px;
            }
          }
        }
        .bottom{
          padding:18px  20px;
          width: 100%;
          height: 48px;
          background: linear-gradient(99deg, #FAEBEE 0%, #FCFBFA 62%);
          opacity: 1;
          display: flex;
          .address{
            width: 10px;
            height: 12px;
            background-image: url("../../assets/addressbg.png");
            background-size:contain;
            background-position:center;
            background-repeat:no-repeat
          }
          .positionAddress{
            height: 16px;
            font-size: 12px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 16px;
            margin-left: 5px;
            margin-top: -2px;
            cursor: pointer;
          }
        }

      }
    }
  }

  .company{
    position: absolute;
    right: 10px;
    width: 260px;
    height: 360px;
    background: #FFFFFF;
    box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.05);
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    position: relative;
    .back{
      width: 260px;
      height: 76px;
      background: linear-gradient(180deg, #F3002B 0%, rgba(255,255,255,0) 95%);
      box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.1);
      border-radius: 4px 4px 4px 4px;
      opacity: 0.1;
    }
    .detail{
      position: absolute;
      top:16px;
      left: 20px;
      bottom: 16px;
      right: 20px;
      .companyDetail{
        width: 64px;
        height: 16px;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 16px;
      }
      .companyLogo{
        margin-top: 24px;
        display: flex;
        .comLogo{
          width: 48px;
          height: 48px;
          border-radius: 2px 2px 2px 2px;
          opacity: 1;
          border: 1px solid rgba(0,0,0,0.02);
        }
        .comLogo:hover{
          transform: scale(1.2);
          transition: transform 0.3s ease-in-out; /* 添加过渡效果 */

        }
        .comName{
          margin:18px auto 20px 10px;
          width: 140px;
          height: 16px;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 16px;
        }
        .comIntro{
          margin-top: 16px;

        }

        .title{
          margin-top: 8px;
          display: flex;

        } .titleName{
            width: 100%;
            height: 16px;
            font-size: 12px;
            font-weight: 500;
            color: #333333;
            line-height: 16px;
          }
        .titleDetail{
          width: 50px;
          height: 16px;
          font-size: 12px;
          font-weight: 400;
          color: #666666;
          line-height: 16px;
        }
      }
    }
  }

}
.phone{
   position: fixed;
   z-index: 9999999999;

   ::v-deep {
     .el-dialog{
       margin:auto !important;
       font-size: 14px;

       top: 35vh;
     }
     .el-dialog__header {
       padding:5px;
       border-bottom: 1px solid #ebebeb;
       .el-dialog__title {
         font-weight: bold;
         padding:15px;
         font-size: 18px;

       }

     }
     .el-dialog__body {
       padding: 10px 15px;
       color: #606266;
       font-size: 14px;
       word-break: break-all;
     }
     .el-button {
       width: 105px;
       height: 28px;
       font-size: 14px;
       line-height:28px;
       border-radius: 5px;
       text-align: center;
       cursor: pointer;
       border: 1px solid var(--main-color);
       padding: 0;
       a {
         display: block;
       }
     }

   }

 }
::v-deep {
  .el-dialog__header {
    border-bottom: 1px solid #ebebeb;
    .el-dialog__title {
      font-weight: bold;
      font-size: 16px;
    }
  }
  .el-button {
    width: 100px;
    height: 28px;
    line-height: 28px;
    border-radius: 5px;
    text-align: center;
    cursor: pointer;
    border: 1px solid var(--main-color);
    color: var(--main-color);
    padding: 0;
    a {
      display: block;
    }
  }
  .el-button--primary {
    border: 1px solid var(--main-color);
    background: var(--main-color);
    color: #fff;
  }
  .el-button:focus,
  .el-button:hover {
    color: var(--main-color);
    border-color: var(--main-color);
    background-color: #fff;
  }
  .el-button--primary:focus,
  .el-button--primary:hover {
    background: var(--main-color);
    border-color: var(--main-color);
    color: #fff;
  }
  .el-dialog__headerbtn:focus .el-dialog__close,
  .el-dialog__headerbtn:hover .el-dialog__close {
    color: var(--main-color);
  }
}
</style>
